import { parse } from "qs";
import {
    QUERY_DATA,
    QUERY_DATA_FROM_DINGTALK
} from "./queryData.types";

export const queryData = parse(window.location.search.slice(1)) as QUERY_DATA;

if (queryData.teamsData) {
    queryData.teamsDataParsed = JSON.parse(queryData.teamsData);
}

// dingtalk data from URL
if (queryData.dingtalkData) {
    const dingtalkDataParsed = JSON.parse(decodeURIComponent(queryData.dingtalkData)) as QUERY_DATA_FROM_DINGTALK;
    queryData.dingtalkDataParsed = dingtalkDataParsed;
}

export const queryFromTeams = queryData.teamsDataParsed || (queryData.teamsuseremail && queryData.teamsnickname);
